import types from "../actions/types";
import { CONSTANTS } from "../constants/app-constant";
const initialState = {};

// eslint-disable-next-line import/no-anonymous-default-export
export function registerUser(state = initialState, action) {
    switch (action.type) {
        case types.ADD_USER_RESET:
            return initialState;
        case types.ADD_USER_REQUEST:
            return { loading: true };
        case types.ADD_USER_SUCCESS:
            return { addUser: action.addUser, loading: false };
        case types.ADD_USER_ERROR:
            const msgCode = action.status || 500;
            const msg = CONSTANTS.errorMsgs[msgCode];

            return { errorMsg: msg, loading: false };
        default:
            return state;
    }
}

export function login(state = initialState, action) {
    switch (action.type) {
        case types.LOGIN_USER_RESET:
            return initialState;
        case types.LOGIN_USER_REQUEST:
            return { loading: true };
        case types.LOGIN_USER_SUCCESS:
            return { user: action.user, loading: false };
        case types.LOGIN_USER_ERROR:
            const msgCode = action.status || 500;
            const msg = msgCode === 401 && action.errMsg?.message !== 'Bad credentials' ? action.errMsg?.message : CONSTANTS.errorMsgs[msgCode];

            return { errorMsg: msg, loading: false };
        default:
            return state;
    }
}

export function userDetails(state = initialState, action) {
    switch (action.type) {
        case types.USER_DETAILS_REQUEST:
            return { loading: true };
        case types.USER_DETAILS_SUCCESS:
            return { userDetails: action.userDetails, loading: false };
        case types.USER_DETAILS_ERROR:
            const msgCode = action.status || 500;
            const msg = CONSTANTS.errorMsgs[msgCode];

            return { errorMsg: msg, loading: false };
        default:
            return state;
    }
}

export function userDetailsFromToken(state = initialState, action) {
    switch (action.type) {
        case types.USER_DETAILS_FROM_TOKEN_REQUEST:
            return { loading: true };
        case types.USER_DETAILS_FROM_TOKEN_SUCCESS:
            return { userDetails: action.userDetailsFromToken, loading: false };
        case types.USER_DETAILS_FROM_TOKEN_ERROR:
            const msgCode = action.status || 500;
            const msg = CONSTANTS.errorMsgs[msgCode];

            return { errorMsg: msg, loading: false };
        default:
            return state;
    }
}

export function getUserActivity(state = initialState, action) {
    switch (action.type) {
        case types.GET_USER_ACTIVITY_REQUEST:
            return { loading: true };
        case types.GET_USER_ACTIVITY_SUCCESS:
            return { userActivity: action.userActivity, loading: false };
        case types.GET_USER_ACTIVITY_ERROR:
            const msgCode = action.status || 500;
            const msg = CONSTANTS.errorMsgs[msgCode];

            return { errorMsg: msg, loading: false };
        default:
            return state;
    }
}

export function setUserActivity(state = initialState, action) {
    switch (action.type) {
        case types.SET_USER_ACTIVITY_REQUEST:
            return { loading: true };
        case types.SET_USER_ACTIVITY_SUCCESS:
            return { setUserActivity: action.userActivity, loading: false };
        case types.SET_USER_ACTIVITY_ERROR:
            const msgCode = action.status || 500;
            const msg = CONSTANTS.errorMsgs[msgCode];

            return { errorMsg: msg, loading: false };
        default:
            return state;
    }
}

export function getUserPreference(state = initialState, action) {
    switch (action.type) {
        case types.GET_PREFERENCE_REQUEST:
            return { loading: true };
        case types.GET_PREFERENCE_SUCCESS:
            return { preference: action.preference, loading: false };
        case types.GET_PREFERENCE_ERROR:
            const msgCode = action.status || 500;
            // Fall back to the generic 500 message for statuses without a
            // mapped copy (403/404/502/503/504…): consumers gate on errorMsg
            // truthiness, so an unmapped status must never yield undefined.
            const msg = CONSTANTS.errorMsgs[msgCode] || CONSTANTS.errorMsgs[500];

            return { errorMsg: msg, loading: false };
        default:
            return state;
    }
}

export function setUserPreference(state = initialState, action) {
    switch (action.type) {
        case types.SET_PREFERENCE_REQUEST:
            return { loading: true };
        case types.SET_PREFERENCE_SUCCESS:
            return { preference: action.preference, loading: false };
        case types.SET_PREFERENCE_ERROR:
            const msgCode = action.status || 500;
            // Same unmapped-status fallback as getUserPreference above.
            const msg = CONSTANTS.errorMsgs[msgCode] || CONSTANTS.errorMsgs[500];

            return { errorMsg: msg, loading: false };
        default:
            return state;
    }
}

export function setFeedback(state = initialState, action) {
    switch (action.type) {
        case types.SET_FEEDBACK_REQUEST:
            return { loading: true };
        case types.SET_FEEDBACK_SUCCESS:
            return { setFeedback: action.feedback, loading: false };
        case types.SET_FEEDBACK_ERROR:
            const msgCode = action.status || 500;
            const msg = CONSTANTS.errorMsgs[msgCode];

            return { errorMsg: msg, loading: false };
        default:
            return state;
    }
}

export function menuOpenStatus(state = { open: false }, action) {
    switch (action.type) {
        case 'OPEN':
            return { open: action.open };
        default:
            return state;
    }
}

export function sendOTP(state = initialState, action) {
    switch (action.type) {
        case types.SEND_OTP_RESET:
            return initialState;
        case types.SEND_OTP_REQUEST:
            return { loading: true };
        case types.SEND_OTP_SUCCESS:
            return {
                loading: false,
                success: true,
                expiresIn: action.payload?.expiresIn,
                isNewUser: action.payload?.isNewUser,
                cooldownUntil: Date.now() + 60000 // 60 second cooldown
            };
        case types.SEND_OTP_ERROR:
            const sendOtpMsg = action.errMsg?.message || action.errMsg || CONSTANTS.errorMsgs[action.status] || 'Failed to send OTP';
            return {
                loading: false,
                error: sendOtpMsg
            };
        default:
            return state;
    }
}

export function verifyOTP(state = initialState, action) {
    switch (action.type) {
        case types.VERIFY_OTP_RESET:
            return initialState;
        case types.VERIFY_OTP_REQUEST:
            return { ...state, loading: true, error: null };
        case types.VERIFY_OTP_SUCCESS:
            return {
                loading: false,
                user: action.payload,
                error: null
            };
        case types.VERIFY_OTP_ERROR:
            const verifyOtpMsg = action.errMsg?.message || action.errMsg || CONSTANTS.errorMsgs[action.status] || 'Invalid OTP';
            const remainingAttempts = action.errMsg?.remainingAttempts;
            return {
                loading: false,
                error: verifyOtpMsg,
                remainingAttempts: remainingAttempts !== undefined ? remainingAttempts : (state.remainingAttempts || 3) - 1
            };
        default:
            return state;
    }
}

export function completeProfile(state = initialState, action) {
    switch (action.type) {
        case types.COMPLETE_PROFILE_RESET:
            return initialState;
        case types.COMPLETE_PROFILE_REQUEST:
            return { loading: true };
        case types.COMPLETE_PROFILE_SUCCESS:
            return {
                loading: false,
                success: true,
                profile: action.payload
            };
        case types.COMPLETE_PROFILE_ERROR:
            const profileMsg = action.errMsg?.message || action.errMsg || CONSTANTS.errorMsgs[action.status] || 'Failed to complete profile';
            return {
                loading: false,
                error: profileMsg
            };
        default:
            return state;
    }
}